/*
 * -----------------------------------------------------------------------
 *  <copyright file="heading-menu/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2022 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popup } from '@progress/kendo-react-popup';
import React, { useRef } from 'react';
import DarkTooltip from '../../dark-tool-tip/dark-tool-tip';
import { HeadingMenuProps } from './heading-menu.interface';
import './styles.scss';

const HeadingMenu = ({
    isOpened,
    toggle,
    children,
    icon,
    title,
    disabled,
    'data-testid': testid,
}: HeadingMenuProps) => {
    const anchor = useRef(null);

    return (
        <>
            <DarkTooltip title={title} placement="top" arrow>
                <div>
                    <button
                        type="button"
                        onClick={toggle}
                        ref={anchor}
                        className="menu-btn grid-action"
                        disabled={disabled}
                        // NOTE: the next line as well as <div> wrapper is a hack to show tooltip even for disabled element
                        style={disabled ? { pointerEvents: 'none' } : {}}
                        data-testid={testid}
                    >
                        <FontAwesomeIcon icon={icon} style={{ fontSize: '18px' }} />
                    </button>
                </div>
            </DarkTooltip>
            <Popup
                anchor={anchor.current}
                show={isOpened}
                anchorAlign={{ horizontal: 'right', vertical: 'bottom' }}
                popupAlign={{ horizontal: 'right', vertical: 'top' }}
                popupClass="popup-content"
            >
                {children}
            </Popup>
        </>
    );
};

export default HeadingMenu;
